// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3JtX9","content":"styles_content__SEooR","selectAll":"styles_selectAll__18d17"};